var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Youtube"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.8135 9.05834C24.6829 8.57376 24.4277 8.13184 24.0732 7.77656C23.7187 7.42128 23.2774 7.16504 22.7931 7.03333C20.9974 6.54026 13.8135 6.53224 13.8135 6.53224C13.8135 6.53224 6.63081 6.52421 4.83399 6.99549C4.35001 7.13326 3.90957 7.39313 3.55495 7.75015C3.20034 8.10717 2.94346 8.54936 2.80897 9.03426C2.3354 10.8299 2.33081 14.5543 2.33081 14.5543C2.33081 14.5543 2.32623 18.297 2.79636 20.0744C3.06009 21.0571 3.83409 21.8334 4.81793 22.0982C6.63196 22.5913 13.7963 22.5993 13.7963 22.5993C13.7963 22.5993 20.9802 22.6074 22.7759 22.1372C23.2603 22.0057 23.7021 21.7501 24.0575 21.3955C24.4128 21.041 24.6695 20.5998 24.802 20.1156C25.2768 18.3211 25.2802 14.5979 25.2802 14.5979C25.2802 14.5979 25.3031 10.854 24.8135 9.05834ZM11.5156 18.0046L11.5213 11.1246L17.492 14.5704L11.5156 18.0046Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.de28938c5f084aec641dfcba8df11eec.svg";
export { ForwardRef as ReactComponent };